<template>
	<div class="container mt-3">
		<div class="gap-2 d-flex mb-3">
			<router-link :to="{name: 'lists'}" class="btn btn-lg btn-outline-secondary flex-grow-1">Список</router-link>
			<div class="btn btn-lg btn-primary flex-grow-1">Группы</div>
		</div>
		
		<div class="mb-3" v-for="group in sortedGroups" :key="group.id">
			<router-link :to="{name: 'group-details', params: {id: group.id}}" class="text-decoration-none">
				<div class="card">
					<div class="card-body">
						<div class="d-flex justify-content-between align-items-start">
							<h3 class="card-title text-break mb-0">{{group.name}}</h3>
							<span class="badge" :class="group.items.filter(el => el.checked).length != group.items.length ? 'bg-success' : 'bg-primary'" style="font-size: 14px;">
								<span>{{group.items.filter(el => el.checked).length}}</span>
								<span> / </span>
								<span>{{group.items.length}}</span>
							</span>
						</div>
						<div class="progress mt-2" style="height: 10px;">
							<div 
								:style="{width: getPercent(group.items.filter(el => el.checked).length, group.items.length)+'%'}" 
								class="progress-bar" 
								:class="group.items.filter(el => el.checked).length != group.items.length ? '' : 'bg-success'">
							</div>
						</div>
					</div>
				</div>
			</router-link>
		</div>
		
		<div class="d-grid mb-3">
			<div class="btn btn-lg btn-primary" @click="doGroupAdd()">Добавить группу</div>
		</div>
	</div>
</template>

<script>
import lib from '@/lib';

export default {
	name: "Groups",
	mixins: lib.mixins,
	computed: {
		sortedGroups(){
			return this.appModel.groups.sort(this.dynamicSort([
				{
					field: 'name',
					order: 'asc',
				}
			]));
		},
	},
	methods: {
		getPercent: lib.getPercent,
		
		dynamicSort(fields){
			return (a, b) => {
				for (let { field, order } of fields){
					if (a[field] !== b[field]){
						if(typeof(a[field]) === 'string'){
							return (order === 'asc' ? a[field].localeCompare(b[field]) : b[field].localeCompare(a[field]));
						} else {
							return (order === 'asc' ? a[field] - b[field] : b[field] - a[field]);
						}
					}
				}
				return 0;  // Если поля идентичны, объекты считаются равнозначными
			};
		},
		
		doGroupAdd(){
			let data = {
				name: prompt('Название группы'),
			};
			if(data.name){
				let ret = this.appModel.doGroupAdd(data);
				if(ret.success){
					
				} else {
					alert(ret.error);
				}
			}
		},
	},
};
</script>
